import { defaultHttpClient } from '../../httpClient';
import type { GetProductCategoriesResponse } from './types';

export const getProductCategories = () => {
  return defaultHttpClient
    .request<GetProductCategoriesResponse>({
      method: 'GET',
      url: '/api/v2/product-categories/',
    })
    .then(result => result.data);
};
